<template>
  <v-card :flat="flat">
    <v-card-title v-if="title" class="py-2 font-weight-black">
      {{ $t(title) }}
    </v-card-title>

    <v-row no-gutters>
      <template v-if="order.delivery.mode === 'TAKE_AWAY'">
        <v-col cols="12" md="4">
          <show-field
              :value="$t('delivery.mode.method.'+order.delivery.mode)"
              :label="$t('delivery.mode.deliveryMode')"
              icon="store"
          />
        </v-col>

        <v-col cols="12" md="4">
          <show-field
              :value="getDate"
              :label="$t('delivery.date')"
              icon="event"
          />
        </v-col>

        <v-col cols="12" md="4">
          <show-field
              :value="getTime"
              :label="$t('delivery.schedule')"
              icon="alarm"
          />
        </v-col>

        <v-col cols="12" md="8">
          <show-field
              :value="order.location.address"
              :label="$t('maps.location.labels.address')"
              icon="location_on"
          />


        </v-col>



      </template>

      <template v-if="order.delivery.mode === 'DELIVERY'">

        <v-col cols="12" md="4">
          <show-field
              :value="$t('delivery.mode.method.'+order.delivery.mode) + ' ' + (order.delivery.timeMode === 'SCHEDULED'  ? $t('delivery.mode.'+order.delivery.timeMode) : '')"
              :label="$t('delivery.mode.deliveryMode')"
              icon="delivery_dining"
          />
        </v-col>

        <v-col cols="12" md="4">
          <show-field
              :value="getDate"
              :label="$t('delivery.date')"
              icon="event"
          />
        </v-col>

        <v-col cols="12" md="4">
          <show-field
              :value="getTime"
              :label="$t('delivery.schedule')"
              icon="alarm"
          />
        </v-col>

        <v-col cols="12" md="8">
          <show-field
              :value="order.location.address"
              :label="$t('maps.location.labels.address')"
              icon="location_on"
          />



        </v-col>

        <v-col v-if="order.location.floor" cols="12" md="4">
          <v-row no-gutters>
            <v-col cols="5">
              <show-field
                  :value="order.location.floor"
                  :label="$t('maps.location.labels.floor')"
                  icon="apartment"
              />
            </v-col>
            <v-col cols="7">
              <show-field
                  :value="order.location.apartment"
                  :label="$t('maps.location.labels.apartment')"
                  icon="meeting_room"
              />
            </v-col>

          </v-row>
        </v-col>




      </template>

    </v-row>
    <v-divider v-if="divider"></v-divider>
  </v-card>
</template>

<script>
import {Dayjs} from "@dracul/dayjs-frontend";
import {ShowField} from '@dracul/common-frontend'

export default {
  name: "OrderLocation",
  components: {ShowField},
  props: {
    divider: {type:Boolean, default: false},
    flat: {type:Boolean, default: false},
    order: {type:Object, required: true},
    title: {type: String, default: 'delivery.mode.title'},

  },
  computed: {
    getDeliveryIntervalTime() {
      return this.$store.getters.getSetting('IntervalDeliveryTime').value
    },
    getRangeScheduleTime() {
      return this.$store.getters.getSetting('RangeScheduleTime').value
    },
    isForToday() {
      return Dayjs().isSame(this.order.delivery.date, 'day')
    },
    getDate(){
      return Dayjs(this.order.delivery.date).format('YYYY-MM-DD')
    },
    getTime() {
      if (this.order.delivery.mode === 'DELIVERY' && this.order.delivery.time) {
        let hour = Dayjs(this.order.delivery.time, "HH:mm")
        let text
        if(this.order.delivery.timeMode === 'AS_SON_AS_POSIBLE'){
          text = hour.format("HH:mm")
        }else{
           let hourTo = hour.add(this.getRangeScheduleTime, 'm')
           text = hour.format("HH:mm") + " a " + hourTo.format("HH:mm")
        }

        return  text
      } else {
        return  this.order.delivery.time
      }
    },
  }
}
</script>

<style scoped>

</style>
